import Api from "./api";

class RobotsApi {
    api = new Api();

    /**
     * Получаем данные, в проекте не используется, просто описание для API
     * @returns {Promise<{
     *     firstUpdate: String,
     *     lastUpdate: String,
     *     statusCode: Number,
     * }[]>}
     */
    getDates() {
        return this.api.get('/robots/dates');
    }

    /**
     * Получаем данные
     * @returns {Promise<{
     *     dateUpdate: String,
     *     robotsSize: Number,
     *     robotsLines: Number,
     *     statusCode: Number,
     *     content: String,
     *     error: String
     *  }>}
     */
    getData(data = {domain: null, date: null}) {
        return this.api.get('/robots/data', data);
    }

    /**
     * Получаем данные для AutoComplete
     * @returns {Promise<[String]>}
     */
    getSuggestion(data = {domain: null}) {
        return this.api.get('/robots/suggestion', data);
    }
}

export default new RobotsApi();
